import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whatsapp-btn',
  standalone: true,
  templateUrl: './whatsapp-btn.component.html',
  styleUrls: ['./whatsapp-btn.component.css']
})
export class WhatsappBtnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
